export default function AboutSection() {
  return (
    <section className="relative w-full py-28 md:py-36 px-6 md:px-10">
      <div className="max-w-4xl mx-auto">
        <div className="mb-12">
          <div className="section-divider mb-8"></div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-light tracking-tight text-foreground-950 mb-8">
            What We Do
          </h2>
        </div>

        <div className="space-y-8">
          <p className="text-base md:text-lg leading-relaxed text-foreground-700 font-light max-w-3xl">
            We are a professional engineering team focused on designing and developing modern digital software solutions for the iOS platform and related technologies. Our expertise lies in building scalable, maintainable, and high-performance systems with a strong focus on usability, stability, and long-term technical quality.
          </p>
          <p className="text-base md:text-lg leading-relaxed text-foreground-700 font-light max-w-3xl">
            Every project we undertake is approached with a commitment to architectural integrity and precision. We believe that well-engineered software should not only meet immediate requirements but also remain adaptable and resilient as technology and business needs evolve over time.
          </p>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          <div className="group">
            <div className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 mb-5">
              <i className="ri-smartphone-line text-xl text-accent-700"></i>
            </div>
            <h3 className="font-heading text-lg font-medium text-foreground-950 mb-3">
              iOS Platform Expertise
            </h3>
            <p className="text-sm leading-relaxed text-foreground-600 font-light">
              Deep specialization in the iOS ecosystem, delivering solutions that leverage platform capabilities to their full potential while maintaining exceptional performance and reliability.
            </p>
          </div>
          <div className="group">
            <div className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 mb-5">
              <i className="ri-stack-line text-xl text-secondary-700"></i>
            </div>
            <h3 className="font-heading text-lg font-medium text-foreground-950 mb-3">
              Scalable Architecture
            </h3>
            <p className="text-sm leading-relaxed text-foreground-600 font-light">
              Systems designed with scalability at their core, ensuring that solutions grow seamlessly with evolving demands while preserving maintainability and code clarity.
            </p>
          </div>
          <div className="group">
            <div className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 mb-5">
              <i className="ri-shield-check-line text-xl text-accent-700"></i>
            </div>
            <h3 className="font-heading text-lg font-medium text-foreground-950 mb-3">
              Long-Term Quality
            </h3>
            <p className="text-sm leading-relaxed text-foreground-600 font-light">
              A relentless focus on stability, testing, and sustainable engineering practices that ensure software remains robust and maintainable throughout its entire lifecycle.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}